import { useState, type ReactNode } from 'react';
import './summaryCurrencySection.css';

type Props = {
  title: string;
  defaultExpanded?: boolean;
  children: ReactNode;
};

const SummaryCurrencySection = ({ title, defaultExpanded = true, children }: Props) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className="summary-currency-section">
      <button
        type="button"
        className="summary-currency-section__header"
        onClick={() => setExpanded((prev) => !prev)}
        aria-expanded={expanded}
      >
        <span
          className={`summary-currency-section__chevron${expanded ? ' summary-currency-section__chevron--expanded' : ''}`}
          aria-hidden="true"
        />
        <span className="summary-currency-section__title">{title}</span>
      </button>
      {expanded && <div className="summary-currency-section__body">{children}</div>}
    </div>
  );
};

export default SummaryCurrencySection;
